import {
  type PartialEventContext,
  type AnnotationOptions,
} from "chartjs-plugin-annotation";
import { isNil } from "lodash";

import { makeFont } from "../../../model-fit-chart/utils/annotation-helpers";
import { REVENUE_ID } from "../const";

export const xPosition = (ctx: PartialEventContext, value: number | null) => {
  if (!isNil(value) && value < ctx.chart.scales.x.max / 2) {
    return "start";
  } else {
    return "end";
  }
};

export const averageAdoptedBudgetMixAnnotation = ({
  averageAdoptedMixSpendIndex,
  averageAdoptedMixValue,
}: {
  averageAdoptedMixSpendIndex: number | null;
  averageAdoptedMixValue: string | null;
}): Record<string, AnnotationOptions> => ({
  averageAdoptedMixSpendLabel: {
    type: "label",
    position: (ctx) => ({
      x: xPosition(ctx, averageAdoptedMixSpendIndex),
      y: "start",
    }),
    xValue: averageAdoptedMixSpendIndex || 0,
    yValue: (ctx) => ctx.chart.scales[REVENUE_ID].max / 2,
    content: averageAdoptedMixValue ? "ADOPTED BUDGET AVG SPEND" : "",
    yAdjust: -4,
    xAdjust: (ctx) =>
      xPosition(ctx, averageAdoptedMixSpendIndex) === "start" ? 4 : -4,
    font: makeFont(),
    color: "#979797",
  },
  averageAdoptedMixSpend: {
    type: "label",
    position: (ctx) => ({
      x: xPosition(ctx, averageAdoptedMixSpendIndex),
      y: "start",
    }),
    xValue: averageAdoptedMixSpendIndex ?? -1,
    yValue: (ctx) => ctx.chart.scales[REVENUE_ID].max / 2,
    yAdjust: 16,
    xAdjust: (ctx) =>
      xPosition(ctx, averageAdoptedMixSpendIndex) === "start" ? 4 : -4,
    content: averageAdoptedMixValue ?? "",
    font: makeFont({
      size: 10,
      weight: "normal",
    }),
    color: "#979797",
  },
  avgAdoptedMixRangeLine: {
    yScaleID: REVENUE_ID,
    xScaleID: "x",
    borderColor: "#979797",
    type: "line",
    borderWidth: 1,
    xMin:
      averageAdoptedMixSpendIndex === null
        ? -1
        : averageAdoptedMixSpendIndex ?? 0,
    xMax:
      averageAdoptedMixSpendIndex === null
        ? -1
        : averageAdoptedMixSpendIndex ?? 0,
    yMin: (ctx) => ctx.chart.scales[REVENUE_ID].min,
    yMax: (ctx) => ctx.chart.scales[REVENUE_ID].max / 2,
  },
});
